import React, { useMemo } from "react";
import { useTicket } from "../../../store/Store";
import { processAdjustmentsData } from "../../general/AppHelpers";
import AdjustmentItem from "../AdjustmentItem";
import { ProductIcon } from "../../general/Icons";
import { useTranslation } from "react-i18next";

const Products = () => {
  const { data: ticketData } = useTicket();
  const { t } = useTranslation();

  const { productAdjustments } = useMemo(
    () => processAdjustmentsData(ticketData?.resource?.adjustments),
    [ticketData]
  );

  const productAdjustmentElements = useMemo(() => {
    return productAdjustments?.map(({ adjustment, associatedTaxes }, index) => (
      <AdjustmentItem
        key={`product-${index}`}
        adjustment={adjustment}
        taxes={associatedTaxes}
      />
    ));
  }, [productAdjustments]);

  if (!productAdjustmentElements?.length) return null;

  return (
    <div className="py-5" data-testid="products-container">
      <div className="flex items-center gap-2 mb-2" data-testid="products-header">
        <ProductIcon />
        <h3 className="text-lg font-medium text-black" data-testid="products-title">
          {t("ticketItemsSections.products")}
        </h3>
      </div>
      <div className="flex flex-col gap-2" data-testid="products-list">{productAdjustmentElements}</div>
    </div>
  );
};

export default Products;
